
import ClickOutside from 'vue-click-outside'
import marketing from '~/mixins/marketing'

export default {
  mixins: [marketing],
  directives: {
    'click-outside': ClickOutside
  },
  computed: {
    items () {
      return [
        { path: this.localePath('/o-nas'), label: this.marketingCopy.about, exact: true },
        { path: this.localePath('/dla-kobiet'), label: this.marketingCopy.women, exact: true },
        { path: this.localePath('/randki-bez-rejestracji'), label: this.marketingCopy.demoDating, exact: true },
        { path: this.localePath('/co-nowego'), label: this.marketingCopy.updates, exact: true },
        { path: this.localePath('/porownania'), label: this.marketingCopy.navComparisons, exact: false },
        { path: this.localePath('/bezpieczenstwo-i-ai'), label: this.marketingCopy.safety, exact: true }
      ]
    },
    currentLabel () {
      const current = this.items.find(item => this.isActive(item))
      return current ? current.label : this.marketingCopy.discover
    }
  },
  watch: {
    '$route.path' () {
      this.closeMenu()
    }
  },
  mounted () {
    this.syncMenuMode()
    window.addEventListener('resize', this.syncMenuMode)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.syncMenuMode)
  },
  methods: {
    isActive (item) {
      const currentPath = this.$route.path.replace(/\/$/, '')
      const itemPath = item.path.replace(/\/$/, '')
      return currentPath === itemPath || (!item.exact && currentPath.startsWith(itemPath + '/'))
    },
    closeMenu () {
      if (this.$refs.menu && window.innerWidth <= 768) this.$refs.menu.removeAttribute('open')
    },
    syncMenuMode () {
      if (!this.$refs.menu) return
      if (window.innerWidth > 768) this.$refs.menu.setAttribute('open', '')
      else this.$refs.menu.removeAttribute('open')
    }
  }
}
